import {Service} from '@s-ui/domain'

export default class GetUrlService extends Service {
  constructor({config, getRemoteUrlService, mapper}) {
    super()
    this._config = config
    this._getRemoteUrlService = getRemoteUrlService
    this._mapper = mapper
    this._pageConfig = this._config.get('page')
    this._technicalDetailsVehiclePageName = this._pageConfig.TECHNICAL_DETAILS_VEHICLE_PAGE_NAME
    this._vehicleConfiguratorPageName = this._pageConfig.VEHICLE_CONFIGURATOR_PAGE_NAME
  }

  _getRemoteUrl = async ({params, urlType}) => {
    const [error, remoteUrlVO] = await this._getRemoteUrlService.execute({
      urlType,
      params
    })
    if (error) return Promise.reject(error)
    return remoteUrlVO
  }

  async execute({listingSectionId, pageName, params, path, query, search}) {
    switch (pageName) {
      case this._technicalDetailsVehiclePageName:
        return this._getRemoteUrl({params, urlType: 'TechnicalData'})
      case this._vehicleConfiguratorPageName:
        return this._getRemoteUrl({params, urlType: 'Configurador'})
      default:
        return this._mapper.setParams({listingSectionId, pageName, params, path, query, search}).map()
    }
  }
}
